import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import CardReportView from "./CardReportView";
import SleepReportView from "./SleepReportView";
import RadioReportView from "./RadioReportView";
import UserReportView from "./UserReportView";
import UserView from "./UserDetailsView";

function Report() {
  const [activeTab, setActiveTab] = useState("user");
  const navigate = useNavigate();

  const getTabClass = (tab) => {
    return `btn ${activeTab === tab ? "btn-primary" : "btn-secondary"}`;
  };

  return (
    <div className="p-3">
      <div className="d-flex gap-2 mb-4">
      <button
          className={getTabClass("user")}
          onClick={() => {
            setActiveTab("user");
            navigate("/report");
          }}
        >
          User
        </button>
        {/* <button
          className={getTabClass("card")}
          onClick={() => {
            setActiveTab("card");
            navigate("/report/card");
          }}
        >
          Card
        </button>
        <button
          className={getTabClass("sleep")}
          onClick={() => {
            setActiveTab("sleep");
            navigate("/report/sleep");
          }}
        >
          Sleep
        </button>
        <button
          className={getTabClass("radio")}
          onClick={() => {
            setActiveTab("radio");
            navigate("/report/radio");
          }}
        >
          Radio
        </button> */}
      </div>

      <Routes>
        <Route path="/" element={<UserReportView />} />
        <Route path="card" element={<CardReportView />} />
        <Route path="sleep" element={<SleepReportView />} />
        <Route path="radio" element={<RadioReportView />} />
        <Route path="user/view/:userId" element={<UserView />} />
      </Routes>
    </div>
  );
}

export default Report;
